import { dashboardApi } from '../store/services/dashboard'
import { authApi } from "../store/services/auth"
import { utilityApi } from "../store/services/utility"; 
import { ssoApi } from "../store/services/sso";
import { cmsApi } from "../store/services/cms"; 
import { baseApi } from "utils/axios/baseApi"; 
import { myProfileApi } from 'store/services/V2/profile'; 
import { supportStaffApi } from 'store/services/SupportStaff';
import { myCaseloadApi } from 'store/services/myCaseload';
import { taskPlanApiV2 } from 'store/services/V2/TaskPlan';
import { achievementsApi } from 'store/services/achievements';
import { noteApi } from 'store/services/note';
import { resourceApi } from 'store/services/resource';
import { schoolBannerApi } from 'store/services/schoolBanners.service';
import { downloadCenterApi } from 'store/services/downloadCenter';

export default [
  baseApi,
  dashboardApi,
  downloadCenterApi,
  authApi,
  utilityApi, 
  myProfileApi, 
  resourceApi,
  schoolBannerApi,
  ssoApi,
  cmsApi, 
  supportStaffApi,
  myCaseloadApi,
  taskPlanApiV2,
  achievementsApi,
  noteApi
]